export const FETCH_PROFILES = 'FETCH_PROFILES';
export const GET_PROFILE = 'GET_PROFILE';
export const CREATE_PROFILE = 'CREATE_PROFILE';
export const PATCH_PROFILE = 'PATCH_PROFILE';